import ComingSoon from '../components/ComingSoon'

export default function Billing() {
  return <ComingSoon title="Billing" subtitle="Stripe customer portal handoff" />
}
